import Setup from './Setup';

export default Setup;
